import ajax from '../../lib/ajax';
import { transformerData } from "../transformer/index";
function fetch(config) {
    if(config.request&&config.request.url){
        return ajax.get(config.request.url).then(data=>{
            if(Error.isError(data)){
                throw data
            }else{
                if(config.transformers&&config.transformers.length){
                    return transformerData(data, config.transformers);
                }else{
                    return data;
                }
            }
        })
    }else{
        return Promise.resolve(config);
    }
    
}

export {fetch}